export const TOKEN_KEY = "kodeera_token";
export const EMAIL_KEY = "kodeera_email";

export const getToken = () => localStorage.getItem(TOKEN_KEY) || "";

export const getEmail = () => localStorage.getItem(EMAIL_KEY) || "";

export const setSession = (token, email) => {
  localStorage.setItem(TOKEN_KEY, token);
  if (email) localStorage.setItem(EMAIL_KEY, email);
};

export const clearSession = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(EMAIL_KEY);
};
